import styled from 'styled-components';

export const StyledComboBox = styled.div`
  position: relative;
`;

export const OptionsList = styled.ul`
  display: grid;
  grid-auto-flow: row;
  padding: 0;
  margin: 0;
  overflow: hidden;
  box-shadow: ${(props) => props.theme.token('drop-shadow-component')};
  border-radius: 10px;
  z-index: 200;
  position: absolute;
  width: inherit;
`;

export const StyledOptionListItem = styled.li`
  cursor: pointer;
  display: table-cell;
  height: auto;
  list-style-type: none;
  color: ${(props) => props.theme.token('text-default')};
  font: ${(props) => props.theme.token('text-style-form-options')};
  background-color: white;

  & + & {
    margin-block-start: -1px;
  }
`;

export const StyledOptionButton = styled.button<{ isFocused?: boolean }>`
  appearance: none;
  cursor: pointer;
  background-color: ${(props) =>
    props.isFocused
      ? props.theme.token('background-focus')
      : props.theme.token('background-input')};
  color: ${(props) => props.theme.token('text-default')};
  font: ${(props) => props.theme.token('text-style-form-options')};
  border: 1px solid ${(props) => props.theme.token('border-color-default')};
  color: inherit;
  display: block;
  font-size: inherit;
  margin: 0;
  padding: 1rem;
  text-align: start;
  width: 100%;
  height: 100%;
  outline: none;
  &:hover {
    background-color: ${(p) => p.theme.token('background-focus')};
  }
  &:disabled {
    cursor: not-allowed;
    background-color: ${(props) => props.theme.token('background-input')};
  }
`;

export const MainPredictionText = styled.span`
  font-weight: bold;
  margin-inline-end: 0.5em;
`;
